export default "__VITE_ASSET__Dptdcmax__"